$(document).ready ->



// WEBPACK FOOTER //
// ./assets/javascripts/pages/catalog.coffee